import axios from 'axios';
import type { Phase } from '@/models/phase';
import type { PhaseData } from '@/models/phasedata';

class PhaseWebservice {
    public load() {
        return axios.get<Phase[]>('/phases');
    }

    public loadForProjectWithWorksheets(projectId: number) {
        return axios.get<Phase[]>('/phases/forProjectWithWorksheets', {
            params: {
                projectId,
            },
        });
    }

    public filter(tradeId: number, projectId: number) {
        return axios.get<PhaseData[]>('/phases/filter', {
            params: {
                tradeId,
                projectId,
            },
        });
    }

    public getById(phaseId: number) {
        return axios.get<Phase>('/phases/getById', {
            params: {
                phaseId,
            },
        });
    }

    public store(phase: Phase) {
        return axios.post('/phases/store', {
            title: phase.title,
            description: phase.description,
            order: phase.order,
            abbreviation: phase.abbreviation,
        });
    }

    public update(phase: Phase) {
        return axios.post('/phases/update', {
            id: phase.id,
            title: phase.title,
            description: phase.description,
            order: phase.order,
            abbreviation: phase.abbreviation,
        });
    }

    public remove(phase: Phase) {
        return axios.post('/phases/remove', {
            id: phase.id,
        });
    }
}

export const phaseWebservice = new PhaseWebservice();
